import clsx from 'clsx';

// Hooks
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { FirstStatsStatusType } from '@/lib/firstStats/firstStatsStatus';
// Lib
import { FIRST_STATS_STATUS } from '@/lib/firstStats/firstStatsStatus';

// Components
import Button from '@/components/base/Button';
import Loader from '@/components/base/Loader';

export type StartButtonBlockProps = {
    firstStatsStatus: FirstStatsStatusType;
    start: () => void;
};

const StartButtonBlock = ({ firstStatsStatus, start }: StartButtonBlockProps) => {
    const { t } = useTranslation('commons');

    const { mutateSocialProfiles } = useSocialProfiles({
        revalidateOnMount: false
    });

    return (
        <div>
            <Button
                className="mb-3 w-full"
                data-testid="first-stats-start-button"
                disabled={firstStatsStatus !== FIRST_STATS_STATUS.READY}
                onClick={() => {
                    mutateSocialProfiles();
                    start();
                }}>
                {t(`modal_first_stats_status.access_analytics.button_label`)}
                {firstStatsStatus === FIRST_STATS_STATUS.LOADING ? (
                    <Loader className="ml-3 h-5 w-5 text-icoBlue" />
                ) : null}
            </Button>
            {firstStatsStatus !== FIRST_STATS_STATUS.READY ? (
                <p
                    className={clsx('text-center text-xs', {
                        'text-icoBlue': firstStatsStatus === FIRST_STATS_STATUS.LOADING,
                        'text-icoRed': firstStatsStatus !== FIRST_STATS_STATUS.LOADING
                    })}>
                    {t(
                        firstStatsStatus === FIRST_STATS_STATUS.LOADING
                            ? 'modal_first_stats_status.access_analytics.content'
                            : 'errors:error_occured'
                    )}
                </p>
            ) : null}
        </div>
    );
};

export default StartButtonBlock;
